import { Injectable } from '@angular/core';
import { BaseService } from '../alcance/services/_base.service';
import { OcorrenciaDBService } from '../database/ocorrencia-db.service';
import { Capacitor } from '@capacitor/core';

@Injectable({
  providedIn: 'root'
})
export class OcorrenciaService extends BaseService {
    override classname: string = 'OcorrenciaService';
    public override route: string = 'ocorrencia';

    public override database = Capacitor.isNativePlatform() ? new OcorrenciaDBService() : new OcorrenciaDBService();
}
